import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import LazyLoad from "react-lazy-load";

import ConteudoTrabalho from "./ConteudoTrabalho";
import Controlos from "../../components/Controlos.jsx";
import ControlosSimples from "../../components/ControlosSimples.jsx";
import Oops from "../../../../pages/Oops.jsx";

class Trabalho extends Component {
    state = {
        nome: "",
        objetivos: "",
        icon: "",
        sameUrl: true,
        dataHora: "",
        //NAO DISPONIVEL
        nao_disponivel: false
    };

    UNSAFE_componentWillReceiveProps(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState(
                {
                    sameUrl: false
                },
                () =>
                    this.setState({
                        sameUrl: true
                    })
            );
        }
    }

    marcarComoNaoDisponivel = () => {
        this.setState({
            nao_disponivel: true
        });
    };

    render() {
        const {
            nome,
            objetivos,
            icon,
            dataHora,
            //REDIRECT
            redirect,
            redirectLink,
            sameUrl,
            //NAO DISPONIVEL
            nao_disponivel
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <div className="trabalho">
                <div className="player-wrapper">
                    {!nao_disponivel ? (
                        <>
                            {sameUrl && (
                                <ConteudoTrabalho
                                    marcarComoNaoDisponivel={this.marcarComoNaoDisponivel}
                                    carregarInfo={(nome, objetivos, icon, dataHora) => this.setState({ nome, objetivos, icon, dataHora })}
                                />
                            )}
                            <Controlos
                                backUrl={
                                    localStorage.getItem("player_back_url")
                                        ? localStorage.getItem("player_back_url")
                                        : `/gerir-curso/${this.props.match.params.curso.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/curso-modulos`
                                }
                                sameUrl={sameUrl}
                                temAnotacoes
                                nome={nome}
                                objetivos={objetivos}
                                icon={icon}
                                dataHora={dataHora}
                            />
                        </>
                    ) : (
                        <>
                            <div className="container">
                                <div className="bloco-nao-disponivel">
                                    <div className="bloco-info nao-disponivel">
                                        <Oops tem_texto texto={"Conteúdo não disponível"} />
                                    </div>
                                </div>
                            </div>
                            <ControlosSimples />
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default Trabalho;
